<template>
    <vx-popover hover arrow placement="top">
        <vx-badge :size="props.size" :color="termStatusColors[props.status]" data-test="status-badge">
            {{ termStatusLabels[props.status] }}
        </vx-badge>
        <template v-slot:content>
            <p class="max-w-xs text-sm text-center" data-test="status-explanation">
                {{ termStatusExplanations[props.status] }}
            </p>
        </template>
    </vx-popover>
</template>

<script lang="ts" setup>
import { VxBadge, VxPopover, type VxBadgeSize } from '@voxie/frontend-components';
import type { TermStatus } from '~/services/adminTermsClient.types';
import { termStatusColors, termStatusExplanations, termStatusLabels } from './termStatus';

const props = withDefaults(
    defineProps<{
        status: TermStatus;
        size?: VxBadgeSize;
    }>(),
    {
        size: 'xs',
    }
);
</script>
